import { Component, Input } from '@angular/core';
import { Exercise, PageActivityStatus, PaginationActivity } from '../pagination.component';

@Component({
  selector: 'onmat-student-progress',
  templateUrl: './student-progress.component.html',
  styleUrls: ['./student-progress.component.scss'],
})
export class StudentProgressComponent {
  @Input() exercise: Exercise;
  @Input() completedStatusClass: string;
  @Input() incompletedStatusClass: string;
  @Input() toDoStatusClass: string;
  @Input() paginationActivity: PaginationActivity;

  protected readonly PageActivityStatus = PageActivityStatus;
}
